import { useAppSelector } from '@/store';
import { useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';

// used to prevent direct access to pages/components that require prior navigation
// search page and 404 page should not use this for obvious reasons
export const NavigationWrapper = ({ children }: React.PropsWithChildren) => {
  const params = useParams();
  const navigate = useNavigate();

  const { site } = useAppSelector(state => state.jbp);

  useEffect(() => {
    if (!site) {
      // redirect to site page if site details are not present
      if (params['mpan'] && params['serviceLine']) {
        navigate(`/site/${params['mpan']}/${params['serviceLine']}`);
        return;
      }
      navigate('/');
    }
  }, [site, navigate, params]);

  if (!site) return null;

  return (
    <>
      <Outlet />
      {children}
    </>
  );
};
